import React, { useContext, useEffect, useState } from 'react'
import { DContext } from '../../context/DataContext'
import Logo from '../../assets/Logo.svg'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { FiChevronDown, FiChevronUp, FiLogIn, FiLogOut, FiX, FiHome, FiMapPin, FiHeart, FiInfo, FiUser } from 'react-icons/fi'
import { MdCurrencyExchange } from 'react-icons/md'

function HeaderOffCanvas(props) {

    const { t } = useTranslation()
    const navPage = useNavigate()
    const { isAuth, setCurrency, currency, handleLogout } = useContext(DContext)
    const [renderCrDropdown, setRenderCrDropdown] = useState(false)

    useEffect(() => {
        document.body.style.overflow = props.isMobileMenuOpen ? 'hidden' : ''
        return () => {
            document.body.style.overflow = ''
        }
    }, [props.isMobileMenuOpen])

    const handleNav = (path) => {
        navPage(path)
        props.setIsMobileMenuOpen(false)
    }

    const renderCurrency = () => {
        if (currency === "usd") {
            return props.ln === "ts" ? "ดอลลาร์" : "Dollar"
        }
        else if (currency === "thb") {
            return props.ln === "ts" ? "เงินบาท" : (props.ln === "fr" ? "Baht thaïlandais" : "Thai Baht")
        }
    }

    return (
        <div className={`fixed inset-0 z-[1100] ${props.isMobileMenuOpen ? '' : 'pointer-events-none'}`} aria-hidden={!props.isMobileMenuOpen}>
            <button className={`absolute inset-0 bg-slate-900/35 transition-opacity ${props.isMobileMenuOpen ? 'opacity-100' : 'opacity-0'}`} onClick={() => props.setIsMobileMenuOpen(false)} aria-label='Close menu overlay' />

            <aside className={`absolute left-0 top-0 h-full w-[86%] max-w-sm bg-white shadow-2xl transition-transform duration-300 ${props.isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full'}`}>
                <div className='flex items-center justify-between border-b border-slate-200 px-4 py-4'>
                    <img className='h-9 w-auto cursor-pointer' src={Logo} alt='Be Alright Krabi logo' onClick={() => handleNav('/')} />
                    <button className='rounded-full border border-slate-300 p-1.5 text-slate-700 transition hover:bg-slate-100' onClick={() => props.setIsMobileMenuOpen(false)} aria-label={t('sliderMenu.closeMenu')}>
                        <FiX />
                    </button>
                </div>

                <div className='flex h-[calc(100%-74px)] flex-col justify-between px-3 py-3'>
                    <ul className='w-full space-y-1'>
                        <li className='flex w-full cursor-pointer items-center gap-3 rounded-lg px-3 py-2.5 text-[17px] text-slate-800 transition hover:bg-slate-100' onClick={() => handleNav('/')} role='button'>
                            <FiHome className='text-lg' />
                            {t("sliderMenu.home")}
                        </li>
                        <li className='flex w-full cursor-pointer items-center gap-3 rounded-lg px-3 py-2.5 text-[17px] text-slate-800 transition hover:bg-slate-100' onClick={() => handleNav('/packages')} role='button'>
                            <FiMapPin className='text-lg' />
                            {t("sliderMenu.tourPackages")}
                        </li>
                        <li className='flex w-full cursor-pointer items-center gap-3 rounded-lg px-3 py-2.5 text-[17px] text-slate-800 transition hover:bg-slate-100' onClick={() => handleNav('/bucket-list')} role='button'>
                            <FiHeart className='text-lg' />
                            {t("sliderMenu.bucketList")}
                        </li>
                        <li className='flex w-full cursor-pointer items-center gap-3 rounded-lg px-3 py-2.5 text-[17px] text-slate-800 transition hover:bg-slate-100' onClick={() => handleNav('/about')} role='button'>
                            <FiInfo className='text-lg' />
                            {t("sliderMenu.aboutUs")}
                        </li>
                        {isAuth && (
                            <li className='flex w-full cursor-pointer items-center gap-3 rounded-lg px-3 py-2.5 text-[17px] text-slate-800 transition hover:bg-slate-100' onClick={() => handleNav('/account')} role='button'>
                                <FiUser className='text-lg' />
                                {t('sliderMenu.account')}
                            </li>
                        )}
                        <li className='flex w-full cursor-pointer items-center gap-3 rounded-lg px-3 py-2.5 text-[17px] text-slate-800 transition hover:bg-slate-100' role='button' onClick={() => setRenderCrDropdown(!renderCrDropdown)}>
                            <span className='inline-flex items-center gap-2'>
                                <MdCurrencyExchange className='text-lg' />
                                {renderCurrency()}
                                {renderCrDropdown ? <FiChevronUp /> : <FiChevronDown />}
                            </span>
                        </li>

                        {renderCrDropdown && <li className='ml-2 cursor-pointer rounded-lg px-3 py-2 text-[16px] text-slate-700 transition hover:bg-slate-100' onClick={() => { setCurrency('thb'); setRenderCrDropdown(false); props.setIsMobileMenuOpen(false) }} role='button'>{'฿'} {props.ln === "ts" && "เงินบาท"} {props.ln === "en" && "Thai Baht"} {props.ln === "fr" && "Baht thaïlandais"}</li>}
                    </ul>

                    {
                        isAuth ?
                            <button className='inline-flex w-full items-center justify-center gap-2 rounded-xl bg-blue-600 px-4 py-2.5 text-lg font-medium text-white transition hover:bg-blue-700' onClick={() => { handleLogout(); props.setIsMobileMenuOpen(false) }}>
                                <FiLogOut />
                                {t('sliderMenu.logout')}
                            </button>
                            : <button className='inline-flex w-full items-center justify-center gap-2 rounded-xl bg-blue-600 px-4 py-2.5 text-lg font-medium text-white transition hover:bg-blue-700' onClick={() => handleNav('/login')}>
                                <FiLogIn />
                                {t('sliderMenu.loginRegister')}
                            </button>

                    }
                </div>
            </aside>
        </div>
    )
}

export default HeaderOffCanvas